import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'his-info-panel',
    templateUrl: './his-info-panel.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HisInfoPanelComponent implements OnInit {

    @Input() i18nKey: string;
    @Input() target?: string;
    @Input() messageLevel: 'info' | 'warn' | 'success' | 'require' = 'info';
    @Input() showPanel: boolean = false;

    public infoHeader: string;
    public infoMessage: string;

    ngOnInit(): void {
        this.infoHeader = 'common.infoHeader.notes';

        if (this.target) {
            let prefix = this.i18nKey.replace('.common.', '.' + this.target + '.').replace('.tab', '');
            this.infoMessage = prefix + '.infoMessage';
        } else {
            this.infoMessage = this.i18nKey;
        }
    }

    public getInfoLevelClass(): string {
        switch (this.messageLevel) {
            case 'warn':
                return 'warnMessage';
            case 'success':
                return 'successMessage';
            case 'require':
                return 'requireMessage';
            default:
                return 'infoMessage';
        }
    }
}
